import { render, staticRenderFns } from "./about_tab.vue?vue&type=template&id=3369664e&scoped=true"
import script from "./about_tab.vue?vue&type=script&lang=js"
export * from "./about_tab.vue?vue&type=script&lang=js"
import style0 from "./about_tab.vue?vue&type=style&index=0&id=3369664e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3369664e",
  null
  
)

export default component.exports